// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__1zF4Q","innerWrap":"layout_innerWrap__1VFL7"};